let defaultState = {
  bg: 'https://s3.eu-west-3.amazonaws.com/scoreplay-scoreboards/default.png',
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'CHANGE_BG':
      return {
        ...state,
        bg: action.bg,
      }
    default:
      return state
  }
}
